module.exports = "<div class=\"ticket-quota__select-box\" *ngIf=\"ticketQuotaCollection.length > 1\">\n\tKontingent:\n\t<select id=\"ticketQuota\" class=\"form__select ticket-quota__select\" [ngModel]=\"selectedTicketQuota?.uuid\" (change)=\"onChange($event.target.value)\">\n\t\t<option *ngFor=\"let element of ticketQuotaCollection;\" [value]=\"element.uuid\">{{element.name}}</option>\n\t</select>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-tickets/ticket-quotas/ticket-quotas.html
// module id = ImSh
// module chunks = 12